<template>
  <v-container grid-list-md text-xs-center >
    <v-layout row wrap >
      <v-flex xs12>
        <v-card dark height="300px" color="alert">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Select the Pixel Grain</h3>
              <div>One is ultra-sharp; Thirty is blob-like</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-list>
            <v-btn
              v-for="n in 30"
              :key='n'
              dark
              fab
              color="deco"
              @click="onPixel(n)"
            >
              {{ n }}
            </v-btn>
            </v-list>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    data () {
      return {
        dialog: true
      }
    },
    computed: {
      setPixel () {
        return this.$store.getters.pixel
      }
    },
    methods: {
      onPixel (n) {
        this.$store.dispatch('pickPixels', n)
        this.$router.push('/')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/toolBox/pixelPicker.vue